import { useState, useEffect } from 'react'
import { Loading, Empty, Tag } from 'react-vant'
import { ArrowLeft, Location, UserO, Play } from '@react-vant/icons'
import { useNavigate, useParams } from 'react-router-dom'
import request from '../../api/request'

export default function LiveDetail() {
    const { id } = useParams()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [schedule, setSchedule] = useState(null)
    const [meetInfo, setMeetInfo] = useState(null)

    // 计算实际显示的实况照片
    const livePhotos = (schedule?.live_photos && schedule.live_photos.length > 0)
        ? schedule.live_photos.map(url => {
            if (url.startsWith('http')) return url;
            const envBaseUrl = import.meta.env.VITE_API_BASE_URL || ''
            let baseUrl = envBaseUrl
            if (envBaseUrl.startsWith('http')) {
                try {
                    baseUrl = new URL(envBaseUrl).origin
                } catch (e) {
                    baseUrl = envBaseUrl.replace('/api', '')
                }
            } else {
                baseUrl = envBaseUrl.replace('/api', '')
            }
            return `${baseUrl}${url}`;
        })
        : []

    useEffect(() => {
        const fetchDetail = async () => {
            setLoading(true)
            try {
                const res = await request.get(`/sports/schedules/${id}/`)
                setSchedule(res)
                // 获取运动会信息
                if (res?.sports_meet_id) {
                    try {
                        const meetRes = await request.get(`/sports/meets/${res.sports_meet_id}/`)
                        setMeetInfo(meetRes)
                    } catch (e) {
                        console.error('获取运动会信息失败', e)
                    }
                }
            } catch (e) {
                console.error(e)
            } finally {
                setLoading(false)
            }
        }
        fetchDetail()
    }, [id])

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: 'var(--canvas-bg, #f8fafc)' }}>
                <Loading type="spinner" color="#056b4f" vertical>加载实况中...</Loading>
            </div>
        )
    }

    if (!schedule) {
        return (
            <div style={{ minHeight: '100vh', background: 'var(--canvas-bg, #f8fafc)', padding: '60px 16px' }}>
                <Empty description="未找到赛程信息" />
            </div>
        )
    }

    const athletes = schedule.lane_assignments || []

    // 展示横幅：没有实况照片时显示运动会信息
    const renderBanner = () => {
        if (livePhotos.length > 0) {
            return (
                <div style={{ width: '100%', height: 220, position: 'relative' }}>
                    <img
                        src={livePhotos[0]}
                        alt="现场实况"
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                </div>
            )
        }

        // 无照片时：品牌蓝渐变展示页
        const meetName = meetInfo?.name || '校园运动会'
        const startDate = meetInfo?.start_date || schedule?.scheduled_date
        const eventName = schedule?.eventName || schedule?.event_name || '比赛项目'

        return (
            <div style={{
                width: '100%', height: 200,
                background: 'linear-gradient(135deg, #055e43 0%, #076f51 50%, #0c8c68 100%)',
                display: 'flex', flexDirection: 'column',
                justifyContent: 'center', alignItems: 'center',
                color: '#fff', position: 'relative', overflow: 'hidden'
            }}>
                {/* 装饰半透圆 */}
                <div style={{
                    position: 'absolute', top: -30, right: -30,
                    width: 140, height: 140, borderRadius: '50%',
                    background: 'rgba(255, 255, 255, 0.08)'
                }} />
                <div style={{
                    position: 'absolute', bottom: -20, left: -20,
                    width: 90, height: 90, borderRadius: '50%',
                    background: 'rgba(255, 255, 255, 0.06)'
                }} />

                {/* 运动会名称 */}
                <div style={{ fontSize: 20, fontWeight: 800, marginBottom: 6, textShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
                    🏅 {meetName}
                </div>
                {/* 项目名称 */}
                {eventName && (
                    <div style={{ fontSize: 15, opacity: 0.95, fontWeight: 600, marginBottom: 10 }}>
                        {eventName}
                    </div>
                )}
                {/* 日期 */}
                {startDate && (
                    <div style={{
                        fontSize: 12, opacity: 0.9,
                        background: 'rgba(255, 255, 255, 0.2)',
                        padding: '3px 14px', borderRadius: 20
                    }}>
                        📅 {startDate}
                    </div>
                )}
            </div>
        )
    }

    return (
        <div style={{ background: 'var(--canvas-bg, #f8fafc)', minHeight: '100vh', paddingBottom: 40 }}>
            {/* 沉浸式星瀚空天蓝页眉 */}
            <div style={{
                background: 'linear-gradient(135deg, #055e43 0%, #076f51 50%, #0c8c68 100%)',
                padding: '44px 16px 20px',
                color: '#fff',
                position: 'relative',
                overflow: 'hidden'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative', zIndex: 1 }}>
                    <div
                        onClick={() => navigate(-1)}
                        style={{
                            width: 36, height: 36, borderRadius: '50%',
                            background: 'rgba(255,255,255,0.2)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            cursor: 'pointer'
                        }}
                    >
                        <ArrowLeft color="#fff" fontSize={18} />
                    </div>

                    <div style={{ textAlign: 'center' }}>
                        <h1 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#fff', letterSpacing: '-0.2px' }}>
                            实况观赛
                        </h1>
                    </div>

                    <div style={{ width: 36 }} />
                </div>
            </div>

            {/* 实况照片轮播 或 运动会信息展示 */}
            <div style={{ width: '100%', overflow: 'hidden', position: 'relative' }}>
                {renderBanner()}
                <div style={{
                    position: 'absolute',
                    top: 14,
                    right: 14,
                    zIndex: 10
                }}>
                    <Tag
                        round
                        style={{
                            background: '#ff3b30',
                            color: '#ffffff',
                            fontWeight: 700,
                            border: 'none',
                            padding: '3px 10px',
                            boxShadow: '0 2px 8px rgba(255, 59, 48, 0.4)'
                        }}
                    >
                        <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                            <span style={{ width: 6, height: 6, background: '#fff', borderRadius: '50%', animation: 'livePulse 1s infinite' }} />
                            LIVE 实况
                        </span>
                    </Tag>
                </div>
            </div>

            <div style={{ padding: '14px 16px' }}>
                {/* 场地与分组信息卡片 */}
                <div style={{
                    background: '#ffffff',
                    borderRadius: 16,
                    padding: 16,
                    marginBottom: 16,
                    boxShadow: 'var(--shadow-card, 0 4px 16px rgba(15, 23, 42, 0.05))',
                    border: '1px solid #f1f5f9'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10 }}>
                        <Location style={{ color: '#056b4f', fontSize: 18 }} />
                        <span style={{ fontSize: 16, fontWeight: 700, color: '#0f172a' }}>{schedule.venue || '主田径场'}</span>
                    </div>
                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                        <span style={{ background: '#f0fdf4', color: '#056b4f', fontSize: 12, fontWeight: 600, padding: '3px 8px', borderRadius: 6 }}>
                            组次: {schedule.heat_number || 1}组
                        </span>
                        <span style={{ background: '#f8fafc', color: '#64748b', fontSize: 12, fontWeight: 500, padding: '3px 8px', borderRadius: 6, border: '1px solid #e2e8f0' }}>
                            轮次: {schedule.round_name || '决赛'}
                        </span>
                        <span style={{ background: '#f8fafc', color: '#64748b', fontSize: 12, fontWeight: 500, padding: '3px 8px', borderRadius: 6, border: '1px solid #e2e8f0' }}>
                            参赛: {schedule.participant_count || athletes.length}人
                        </span>
                    </div>
                </div>

                {/* 参赛选手列表 */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10 }}>
                    <div style={{ width: 4, height: 16, background: '#056b4f', borderRadius: 2 }} />
                    <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#0f172a' }}>参赛运动员</h3>
                </div>

                <div style={{
                    background: '#ffffff',
                    borderRadius: 16,
                    padding: '4px 16px',
                    boxShadow: 'var(--shadow-card, 0 4px 16px rgba(15, 23, 42, 0.05))',
                    border: '1px solid #f1f5f9'
                }}>
                    {athletes.map((a, index) => {
                        const isLast = index === athletes.length - 1;
                        return (
                            <div
                                key={index}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '14px 0',
                                    borderBottom: isLast ? 'none' : '1px solid #f1f5f9'
                                }}
                            >
                                <div style={{
                                    width: 36, height: 36, borderRadius: 18,
                                    background: '#f0fdf4',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    marginRight: 12, color: '#056b4f', fontWeight: 700, fontSize: 14,
                                    border: '1px solid #a7f3d0'
                                }}>
                                    <UserO />
                                </div>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ fontSize: 15, fontWeight: 700, color: '#0f172a' }}>
                                        {a.student_name || a.name || '参赛选手'}
                                    </div>
                                    <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>
                                        {a.class_name || a.school || '班级待定'}
                                    </div>
                                </div>
                                <div>
                                    <span style={{
                                        background: '#f8fafc',
                                        color: '#056b4f',
                                        fontSize: 12,
                                        fontWeight: 700,
                                        padding: '3px 10px',
                                        borderRadius: 6,
                                        border: '1px solid #e2e8f0'
                                    }}>
                                        {a.lane ? `${a.lane}道` : `道次 ${index + 1}`}
                                    </span>
                                </div>
                            </div>
                        );
                    })}
                    {athletes.length === 0 && (
                        <div style={{ padding: '24px 0', textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>
                            暂无分配名单
                        </div>
                    )}
                </div>

                <div style={{ marginTop: 20, textAlign: 'center', color: '#94a3b8', fontSize: 12 }}>
                    <p>温馨提示：现场画面仅供展示，准确成绩以官方报表为准</p>
                </div>
            </div>

            <style>{`
                @keyframes livePulse {
                    0% { transform: scale(1); opacity: 1; }
                    50% { transform: scale(1.3); opacity: 0.6; }
                    100% { transform: scale(1); opacity: 1; }
                }
            `}</style>
        </div>
    )
}
